import { onMount } from "solid-js";

import AppRouter from "@repo/utils-solid/AppRouter";

export default function Root() {
  onMount(() => {
    AppRouter.replace("/users");
  });
}
